import React from "react";
import { Spin } from "antd/lib";
import { LoadingOutlined } from "@ant-design/icons";

const LoadingSpinner = () => {
  return (
    <div style={styles.spinnerContainer}>
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 84,
              color: "black",
              fontWeight: "lighter",
            }}
          ></LoadingOutlined>
        }
      ></Spin>
    </div>
  );
};

const styles = {
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "#F7FAF2",
    zIndex: 1000,
  },
};

export default LoadingSpinner;
